import View from "ol/View";
import { fromNullable, fromPredicate } from "./option";
import { fromLonLat } from "ol/proj";

export type Nullable<T> = T | null;
export type StructureSize = "small"|"medium"|"big"

export interface DataProps {
  id: number;
  name: string;
  statut: string;
  sector: string;
  size:StructureSize;
  program: string[];
  description: Nullable<string>;
  image: Nullable<string>;
  creation_date: Nullable<string>;
  address: Nullable<string>;
  structure_type: string;
  url: Nullable<string>;
}
export type PropKey = keyof DataProps;

export type Lang = "fr" | "nl";
const isLang = (l: unknown): l is Lang =>
  typeof l === "string" && (l === "fr" || l === "nl");


export type Legend = "sector" | "program" | "statut";
export const legends: Legend[] = ["sector", "program", "statut"];
export type Category =
  | "asbl"
  | "scrl"
  | "autre"
  | "technologie"
  | "service"
  | "sante"
  | "mobilite"
  | "logement"
  | "innovation"
  | "environnement"
  | "emploi"
  | "education"
  | "culture"
  | "communication"
  | "alimentation"
  | "blossom"
  | "seeds"
  | "innovate"
  | "share"
  | "pollinize";

export const categories = () =>
  legends.reduce((acc, leg) => acc.concat(getCategory(leg)), [] as Category[]);
interface State {
  lang: Lang;
  projects: DataProps[];
  legend: Legend;
  category: Nullable<Category>;
  colors: string[];
  colorDefault: string;
  radiusDefault: number;
  categories: { [key in Legend]: string[] };
  view: View;
  searchInput: string;
}

type StateKey = keyof State;

const state: State = {
  lang: fromPredicate<Lang>(isLang)((window as any).appLanguage).getOrElse(
    "fr",
  ),
  projects: [],
  legend: "sector",
  // colors: [
  //   "#2ba6ff",
  //   "#335496",
  //   "#42dd73",
  //   "#ce3943",
  //   "#df37c3",
  //   "#ff9c3a",
  //   "#373e46",
  //   "#c8e6cf",
  //   "#191760",
  //   "#b3e5b5",
  // ],
  category: null,
  colors: [
    "#95c11e",
    // "#BFE85E",
    "#009c98",
    // "#36A5A0",
    "#fccf03",
    // "#FF9C3A",
    "#61bfc2",
    "#D81B60",
    "#1E88E5",
    "#165923",
    "#42DD73",
    "#FBA3EE",
    "#9325E0",
    "#64DEEC",
    "#719945",
    "#2710EF",
    "#F5E6A5",
    "#B70707",
    "#186B73",
    "#001392",
    "#9175F3",
    "#3D3029",
    "#740557",
  ],
  colorDefault: "#595959",
  radiusDefault: 6,
  categories: {
    // structure_type: ["asbl", "scrl", "autre"] as Category[],
    sector: [
      "technologie",
      "service",
      "sante",
      "mobilite",
      "logement",
      "innovation",
      "environnement",
      "emploi",
      "education",
      "culture",
      "communication",
      "alimentation",
    ] as Category[],
    program: [
      "seeds",
      "blossom",
      "innovate",
      "share",
      "pollinize",
      "coworking",
    ] as Category[],
    statut: [
      "actif",
      "inactif",
    ]
  },
  view: new View({
    center: fromLonLat([4.34878, 50.85045]),
    zoom: 14,
    maxZoom: 19,
    minZoom:12
  }),
  searchInput: "",
};
const observers: [key: StateKey, fn: () => void][] = [];

export const get = <K extends StateKey>(key: K): State[K] => state[key];

export const set = <K extends StateKey>(key: K, val: State[K]) => {
  state[key] = val;
  observers.forEach(([okey, fn]) => {
    if (key === okey) {
      fn();
    }
  });
};

export const observe = (key: StateKey, fn: () => void) =>
  observers.push([key, fn]);

export const getColor = (i: number) => {
  if (i < 0) {
    return get("colorDefault");
  }
  const colors = get("colors");
  const colorIndex = i % colors.length;
  return colors[colorIndex];
};

export const getCategory = (legend: Legend) =>
  get("categories")[legend] as Category[];

export const getView = () => get("view");
export const setView = (newView: { center: [number, number]; zoom: number }) =>
  set("view", new View({ center: newView.center, zoom: newView.zoom }));

export const zoomIn = () => {
  const view = getView()
  fromNullable(view.getZoom()).map(currentZoom=> view.setZoom(currentZoom+1)) 
  set("view", view)
}
export const zoomOut = () => {
  const view = getView()
  fromNullable(view.getZoom()).map(currentZoom=> view.setZoom(currentZoom-1)) 
  set("view", view)
}